import moment from "moment";

const oDataOperatorMap = {
  contains: "contains",
  equals: "eq",
  startsWith: "startswith",
  endsWith: "endswith",
  isEmpty: "isempty",
  isNotEmpty: "isnotempty",
  isAnyOf: "isanyof",
};

export const muiFilterToODataFilter = (filters) => {
  const oDataQueryFilter = [];

  filters.items.forEach((filter) => {
    const { field, operator, value } = filter;

    const oDataOperator = oDataOperatorMap[operator] || "";
    const date = moment(value);

    if (!value) {
      return;
    }

    if (oDataOperator) {
      oDataQueryFilter.push({
        [field]: { [oDataOperator]: value },
      });
      return;
    }

    if (date.isValid()) {
      oDataQueryFilter.push({
        [field]: {
          ge: new Date(date.format("MM/DD/YYYY")),
          le: new Date(date.add(1, "day").format("MM/DD/YYYY")),
        },
      });
    }
  });

  return oDataQueryFilter;
};
